export const FAMILY_FRIENDS_SECTION_ANCHOR_KEY = 'family-friends-details';
export const HEALTHIERSG_OFFBOARDED_CLINIC_ANCHOR_KEY = 'offboarded-clinic';
export const HEALTHIERSG_HEALTHPLAN_CHECKIN_ANCHOR_KEY = 'healthplan-checkin';
